import { Button, Checkbox, Input, InputNumber, Select, Tabs } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Icon, { ICON_NAME } from "../../../../../components/Icon";
import SelectFishHealth from "../../../../../components/Location/FishHealth/SelectFishHealth";
import Footer from "../../../../../components/Popup/_components/Footer";
import { callEventPopup, setPopup } from "../../../../../contexts/PopupContext";
import { IResponseUpdateUnit, SiteService } from "../../../../../util/services/site";
import { renderOpts, showErrorResponse } from "../../../../../util/varibles/global";
import { IDisease, IUnit } from "../../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../../util/varibles/message";
import { EditUnitProvider, getEditUnit, useEditUnit } from "./EditUnitContext";
import styles from "./style.module.scss";

// const regexValid = new RegExp(/^\d+(?:\.\d+)?(?:,\d+(?:\.\d+)?){2}$/);
const regexValid = new RegExp(/^\d+(?:\.\d+)?(?:,\s*\d+(?:\.\d+)?){2}$/);

const LiceCounting = () => {
    const [lice, setData] = useEditUnit(state => state.data.lice);
    const [value, setValue] = useState((() => {
        if (lice) {
            const { stationary_lice, mobile_lice, female_lice } = lice || {};
            return [stationary_lice?.value || 0, mobile_lice?.value || 0, female_lice?.value || 0].join(', ');
        }
        return ""
    })());

    const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setValue(value)
    }, [])

    useEffect(() => {
        if (value.trim() === '') {
            setData(({ data: prev }) => ({ data: { ...prev, lice: undefined } }));
        } else {
            const [stationary, mobile, female] = value.trim().split(',')
            setData(({ data: prev }) => ({
                data: {
                    ...prev,
                    lice: {
                        stationary_lice: { value: +stationary },
                        mobile_lice: { value: +mobile },
                        female_lice: { value: +female }
                    }
                }
            }));
        }
    }, [value, setData]);

    const handleKeyDown = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        const actionKeys = new Set(["ArrowLeft", "ArrowRight", "Backspace", "Tab", "End", "Home", "Delete", "F12"]);
        if (e.ctrlKey || e.metaKey || actionKeys.has(e.key)) {
            return;
        }
        const el = e.currentTarget;
        const pos = el.selectionStart ?? 0;
        const { value } = el;

        const finish = () => {
            e.preventDefault();
            e.stopPropagation();
            return false
        }
        const move = (i: number) => {
            const { value: currentValue } = el;
            const nextComma = currentValue.indexOf(',', i);
            if (nextComma !== -1) {
                const start = currentValue[nextComma + 1] === " " ? nextComma + 2 : nextComma + 1;
                let end = start;
                while (currentValue[end] === ' ') end++;
                while (end < currentValue.length && /[0-9.]/.test(currentValue[end])) end++;
                el.setSelectionRange(start, end);
            } else {
                const firstComma = currentValue.indexOf(',');
                let start = 0;
                let end = firstComma !== -1 ? firstComma : currentValue.length;
                el.setSelectionRange(start, end);
            }
        }
        const keys = new Set([" ", ".", ",", "Tab"]);
        const regexInt = new RegExp(/^[0-9]*$/);
        if (keys.has(e.key)) {
            const charBefore = value[(pos) - 1];
            switch (e.key) {
                case " ":
                    if (charBefore === "." || charBefore === ",") {
                        setValue(prev => prev.split(",").map(item => +item).join(", "));
                        setTimeout(() => move(pos - 1), 5);
                    }
                    const commas = Array.from(value.matchAll(/,/g)).map(m => m.index!);
                    if (regexInt.test(charBefore) && commas.length < 2) {
                        setValue(prev => `${prev.slice(0, pos)}${prev[pos] === " " ? "," : ", "}${prev.slice(pos)}`)
                    }
                    if (commas.length === 2) {
                        move(pos);
                    }
                    if (charBefore === " ") {
                        const start = el.selectionStart ?? 0;
                        const end = el.selectionEnd ?? 0;
                        if (start === end) {
                            setValue(prev => `${prev}${value[start - 1] === "," ? " 0" : 0}`);
                        }
                    }
                    finish();
                    break;
                case ".":
                    if (charBefore === ".")
                        finish();
                    break;
                case ",":
                    const count = (value.match(/,/g) || []).length;
                    if (count === 2) {
                        if (charBefore === " ") {
                            setValue(prev => prev.split(",").map(item => +item.trim()).join(", "));
                        }
                        move(pos);
                        finish();
                    } else {
                        if (charBefore === " " || charBefore === ",") {
                            setValue(prev => `${prev.trim()} 0`);
                        } else if (charBefore === ".") {
                            setValue(prev => prev.split(",").map(item => +item).join(", "));
                        } else if (regexInt.test(charBefore)) {
                            setValue(prev => `${prev.slice(0, pos)}${prev[pos] === " " ? "," : ", "}${prev.slice(pos)}`)
                            setTimeout(() => move(pos - 1), 5);
                            finish();
                        }
                    }
                    break;
            }
        } else {
            if (!regexInt.test(e.key)) {
                finish();
            }
        }
    }, [])

    const handlePaste = useCallback((e: React.ClipboardEvent<HTMLInputElement>) => {
        const text = e.clipboardData.getData('text');
        if (regexValid.test(text)) {
            setValue(text.split(',').join(', '));
        }
        e.preventDefault();
        e.stopPropagation();
        return false
    }, []);

    const handleFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
        const { value } = e.target;
        const index = value.indexOf(",");
        e.target.setSelectionRange(0, index);
    }, [])

    const handleBlur = useCallback(() => {
        if (!regexValid.test(value.trim())) {
            setValue("");
            notify.error(NotifyCode.E49)();
        }
    }, [value]);

    return <div className='mb-3 mt-2'>
        <div className=' mb-1'>Stationary, Mobile, Adult female lice</div>
        <Input
            min={0}
            className="h-[36px]"
            placeholder="Stationary, Mobile, Adult female lice"
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            value={value}
        />
        <div className="text-comment italic">
            Each lice type is separated by a comma “,”.
        </div>
    </div>
}

const MortalityCount = () => {
    const [mortalityCount, setData] = useEditUnit(state => state.data.mortality_count);

    return <div className='mb-3 mt-2'>
        <div className=' mb-1'>Mortality count</div>
        <InputNumber
            className={styles.inputNunber}
            value={mortalityCount}
            placeholder="Log the mortality count for today"
            onChange={value => {
                setData(({ data: prev }) => {
                    return { data: { ...prev, mortality_count: value === null ? undefined : value } }
                })
            }}
        />
    </div>
}

const FishHealthAndDisease = () => {
    const [fishHealth] = useEditUnit(state => state.data.fish_health);
    const [unitIds] = useEditUnit(state => state.data.unitIds);
    const [unitDiseases, setData] = useEditUnit(state => state.data.unit_diseases);
    const get = getEditUnit();
    const { unit, units, diseases } = get();
    const { id: targetId } = unit || {};

    const [replicate, setReplicate] = useState(false);

    const handleReplicateChange = useCallback(() => {
        setReplicate(prev => {
            if (prev)
                setData(({ data: prev }) => ({ data: { ...prev, unitIds: [] } }))
            return !prev
        })
    }, [setData]);
    const ids = useMemo(() => new Set(unitIds.map(item => item.id)), [unitIds]);

    return <>
        <div className='mb-3 '>
            <div className='text-comment mb-1'>Select fish health status:</div>
            <SelectFishHealth
                value={fishHealth}
                onChange={fish_health => setData(({ data: prev }) => ({ data: { ...prev, fish_health } }))}
            />
        </div>
        <div className='mb-3'>
            <div className='text-comment mb-1'>
                Select disease
            </div>
            <Select
                mode='tags'
                popupMatchSelectWidth={false}
                className='select-mode-tag w-full'
                value={(unitDiseases?.types || []).map(item => item.id)}
                options={renderOpts<IDisease>(diseases)}
                onSelect={(_, opt) => {
                    setData(({ data: prev }) => {
                        const { root } = opt || {};
                        const { unit_diseases } = prev;
                        const { types = [] } = unit_diseases || {};
                        return { data: { ...prev, unit_diseases: { types: [...types, root] } } }
                    })
                }}
                onDeselect={(_, opt) => setData(({ data: prev }) => {
                    const { value } = opt || {};
                    const { types = [] } = prev.unit_diseases || {};
                    return { data: { ...prev, unit_diseases: { types: types.filter(sub => sub.id !== value) } } }
                })}
            />
        </div>
        <div>
            {!replicate
                ? <div className='link mb-1' onClick={handleReplicateChange}>
                    Replicate to other units
                </div>
                : <>
                    <div className='flex items-center gap-2 mb-1'>
                        <div className='font-[600]'>
                            Replicate to other units
                        </div>
                        <Button className='bt-ghost' data-icon='true' onClick={handleReplicateChange}>
                            <Icon icon={ICON_NAME.CLOSE} />
                        </Button>
                    </div>
                    <div>
                        {units.map(item => item.id === targetId ? null :
                            <Checkbox
                                key={item.id}
                                checked={ids.has(item.id)}
                                onChange={({ target }) => {
                                    setData(({ data: prev }) => {
                                        const { unitIds: old } = prev;
                                        const newData = target.checked ? [...old, { id: item.id, name: item.unit_id }] : old.filter(sub => sub.id !== item.id)
                                        return { data: { ...prev, unitIds: newData } }
                                    })
                                }}
                            >
                                {item.unit_id}
                            </Checkbox>)}
                    </div>
                </>}
        </div>
    </>
}

const BottomControls = () => {
    const getData = getEditUnit();
    const [loading, set] = useEditUnit(state => state.loading);
    const { onClose } = callEventPopup();
    const handleSave = () => {
        const { data, siteId, unit, onSave } = getData();
        const { fish_health, unit_diseases, lice, mortality_count, unitIds } = data;
        const { types = [] } = unit_diseases || {};
        const name = unitIds.length > 0 ? unitIds.map(item => item.name).join(', ') : [unit?.unit_id];
        const payload = {
            fish_health,
            lice,
            mortality_count,
            site_id: siteId,
            unit_diseases: { types: types.map(item => item.id) },
            unit_ids: Array.from(new Set([unit?.id || '', ...unitIds.map(item => item.id)]))
        };
        set({ loading: true });
        SiteService.updateUnits(payload)
            .then((rs) => {
                set({ loading: false });
                notify.success(NotifyCode.S2)([name]);
                onSave(rs)
                onClose()
            })
            .catch((error) => {
                set({ loading: false });
                showErrorResponse(notify[NotifyCode.E35]([name]), error);
            })
    }

    return <Footer
        cancel={{ click: onClose }}
        ok={{ loading, click: handleSave }}
    />
}

interface IProps {
    unit: IUnit
    units: IUnit[]
    siteId?: string
    diseases: IDisease[]

    onSave(value: IResponseUpdateUnit[]): void
}

const EditUnit: React.FC<IProps> = ({ unit, units, siteId, diseases, onSave }) => {
    const set = setPopup();
    useEffect(() => {
        set(({ modalProps = {} }) => ({
            modalProps: {
                ...modalProps, width: 600,
                style: {
                    height: '500px'
                }
            }
        }))
    }, [set]);

    return <EditUnitProvider unit={unit} units={units} siteId={siteId} diseases={diseases} onSave={onSave} >
        <div className="h-[260px]">
            <Tabs
                defaultActiveKey="1"
                tabBarStyle={{ height: "40px" }}
                items={[
                    {
                        key: '1',
                        label: 'Lice counting',
                        children: <LiceCounting />,
                    },
                    {
                        key: '2',
                        label: 'Mortality count',
                        children: <MortalityCount />,
                    },
                    {
                        key: '3',
                        label: 'Fish Health & Disease',
                        children: <FishHealthAndDisease />,
                    },
                ]}
            />
        </div>
        <BottomControls />
    </EditUnitProvider>;
};

export default EditUnit;
